import type { ExerciseLogRepository } from '../../../application/ports/ExerciseLogRepository';
import type { ExerciseLogId, WorkoutSessionId } from '../../../domain/shared/ids';
import type { ExerciseLog } from '../../../domain/workout/ExerciseLog';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { ExerciseLogMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieExerciseLogRepository implements ExerciseLogRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(log: ExerciseLog): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.exerciseLogs.put(ExerciseLogMapper.toRecord(log));
    });
  }

  public findById(id: ExerciseLogId): Promise<ExerciseLog | null> {
    return executePersistence('read', async () => {
      const record = await this.database.exerciseLogs.get(id);
      return record ? ExerciseLogMapper.fromRecord(record) : null;
    });
  }

  public listBySession(workoutSessionId: WorkoutSessionId): Promise<readonly ExerciseLog[]> {
    return executePersistence('read', async () => {
      const records = await this.database.exerciseLogs
        .where('workoutSessionId')
        .equals(workoutSessionId)
        .sortBy('order');
      return records.map((record) => ExerciseLogMapper.fromRecord(record));
    });
  }

  public delete(id: ExerciseLogId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.exerciseLogs.delete(id);
    });
  }
}
